module.exports = __webpack_public_path__ + "static/media/MKStoneMountainEXTA0009_design_clean_v002.a0e705a5.webp";